export default "__VITE_ASSET__Kj27mjq___"